<template>
  <AppLayout>
    <template #middle>
      <ChatContent />
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import ChatContent from '@/features/ui/pages/chat/chat-content/chat-content.vue'
</script>
